import _ from 'lodash';
import React from 'react';
import QRCode from 'qr.js';
import Background from './background.png';
import BackgroundA4 from './backgroundA4.jpg';
import PropTypes from 'prop-types';

import BarcodeBackground from './barcode_background';


const barcodeCell = 2.68;
const barcodeSize = 2.15;
const barcodeSpace = .53;
const barcodeLeft = 16.7;
const barcodeTop = 31;

const Box = props => <div
    style={{
        position: 'absolute',
        top: `${props.top}mm`,
        left: `${props.left}mm`,
        width: `${barcodeSize}mm`,
        height: `${barcodeSize}mm`,
        marginLeft: `${barcodeSpace}mm`,
        marginTop: `${barcodeSpace}mm`,
        backgroundColor: 'black',
    }}>
</div>;

export default class Barcode extends React.PureComponent {

    static defaultProps = {
        titleMarginRight: 0,
        titleMarginUp: 0,

    }
    static propTypes = {
        titleMarginRight: PropTypes.number,
        titleMarginUp: PropTypes.number,
    }

    hammingCode(n) {
        let data = _.reverse(_.map(n.toString(2), bit => bit === '1'));
        let hammingCode = Array(45).fill(false);
        for (
            let i = 0, j;
            (j = i - Math.floor(Math.log2(i+1)) - 1) < data.length;
            i++
        ) {
            hammingCode[i] = data[j];
            if (Math.floor(Math.log2(i+1)) === Math.log2(i+1)) {
                hammingCode[i] = 0;
                continue;
            }
            for (let k = 0; k < Math.log2(i+1); k++) {
                if ((i+1) & Math.pow(2, k) && hammingCode[i]) {
                    hammingCode[Math.pow(2, k) - 1] ^= 1;
                }
            }
        }
        return hammingCode;
    }
    top = {
        name: !this.props.background ? 42 : 47 ,
        lname : !this.props.background ? 46 :51,
        fatherName : !this.props.background ? 50 :55,
        examination: !this.props.background ? 38: 43 ,
        city: !this.props.background ? 42 :47 ,
        school : !this.props.background ? 46 :51 ,
        grade : !this.props.background ? 50 : 55 , 
        national_id: !this.props.background ? 38 : 43,
    }
    render() {
        let hammingCode;
        let qrcode;
        const debugOldBarcode = false ;
        
        if (debugOldBarcode || (this.props.qrcode && this.props.barcodeURL == undefined)) {
            qrcode = new QRCode(this.props.id.toString(), {
                typeNumber: -1,
                errorCorrectLevel: QRCode.ErrorCorrectLevel['Q'],
            });
        }
        else {
            hammingCode = this.hammingCode(this.props.id);
        }
        return <div
            style={{
                width: `${(this.props.examination.paper_type === 14 ? 210 : 148)}mm`,
                height: `${(this.props.examination.paper_type === 14 ? 297 : 210)}mm`,
                margin: 0,
                position: 'relative',
                fontSize: '.9em',
                pageBreakAfter: 'auto', 
                fontFamily: 'IRANSans'
            }}>
            {this.props.background
                //?<BarcodeBackground //Very bad performance
                ?<img src={this.props.examination.paper_type === 14 ? BackgroundA4 : Background}
                    style={{
                        width: 'calc(100% - 14mm)',
                        position: 'absolute',
                        top: '5.5mm',
                        left: '6.5mm',
                    }}
                />
                : null
            }
            {this.props.qrcode
                ? (
                    this.props.barcodeURL && !debugOldBarcode
                    ?
                    <img src={this.props.barcodeURL} 
                        style={{
                            // position: 'absolute',
                            position: 'absolute', 
                            // top: '20mm',
                            // left: '20mm', 
                            marginTop: '20mm',
                            marginRight: `${(this.props.examination.paper_type === 14 ? 148 : 108)}mm`, 
                            width: '20mm',
                            height: '20mm', 
                    }}/>
                    :
                    <svg
                        style={{
                            // position: 'absolute',
                            position: 'static', 
                            // top: '20mm',
                            // left: '20mm', 
                            marginTop: '20mm',
                            marginRight: `${(this.props.examination.paper_type === 14 ? 148 : 108)}mm`, 
                            width: '20mm',
                            height: '20mm', 
                        }}
                        viewBox={`0 0 ${qrcode.modules.length} ${qrcode.modules.length}`}
                        preserveAspectRatio='none'>
                        {_.map(qrcode.modules, (row, y) => _.map(row, (module, x) => <rect
                            x={x}
                            y={y}
                            width='1'
                            height='1'
                            style={{
                                fill: module ? 'black' : 'white',
                            }}
                        />))}
                    </svg>
                )
                : <span>
                    <Box
                        top={barcodeTop}
                        left={barcodeLeft}
                    />
                    <Box
                        top={barcodeTop}
                        left={barcodeLeft + barcodeCell * 31}
                    />
                    <Box
                        top={barcodeTop + barcodeCell * 2}
                        left={barcodeLeft}
                    />
                    <Box
                        top={barcodeTop + barcodeCell * 2}
                        left={barcodeLeft + barcodeCell * 31}
                    />
                    {_.map(Array(90), (_i, index) => {
                        
                        const x = 30 - index % 30;
                        const y = Math.floor(index / 30);
                        const i = index % 45;
                        return hammingCode[i]
                            ? <Box
                                key={index}
                                top={barcodeTop + y * barcodeCell}
                                left={barcodeLeft + x * barcodeCell}
                            />
                            : null;
                    })}
                </span>
            }
            <div
                style={{
                    position: 'absolute',
                    top: (42.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${16 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('Student Number')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 43 : this.top.national_id)+Number(this.props.titleMarginUp)}mm`,
                    right: `${39 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 26 : 0)}mm`,
                }}>
                {(this.props.student.national_id || '').persian()}
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: (46.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${16+Number(this.props.titleMarginRight) + (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('Firstname')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 47 : this.top.name)+Number(this.props.titleMarginUp)}mm`,
                    right: `${21+Number(this.props.titleMarginRight) + (this.props.examination.paper_type === 14 ? 33 : 0)}mm`,
                }}>
                {(this.props.student.firstname || '').persian()}
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: (50.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${16 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('Lastname')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 51 : this.top.lname)+Number(this.props.titleMarginUp)}mm`,
                    right: `${33 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 28 : 0)}mm`,
                }}>
                {(this.props.student.lastname || '').persian()}
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: (54.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${16 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('Father Name')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 55 : this.top.fatherName)+Number(this.props.titleMarginUp)}mm`,
                    right: `${26 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 28 : 0)}mm`,
                }}>
                {(this.props.student.father_name || '').persian()}
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: (42.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${75+Number(this.props.titleMarginRight) + (this.props.examination.paper_type === 14 ? 36-8 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('Examination')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 43 : this.top.examination)+Number(this.props.titleMarginUp)}mm`,
                    right: `${84 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                }}>
                {(this.props.examination.title || '').persian()}
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: (46.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${75 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 36-8 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('City')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 47 : this.top.city)+Number(this.props.titleMarginUp)}mm`,
                    right: `${82+Number(this.props.titleMarginRight) + (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                }}>
                {(this.props.student.school.city.name || '').persian()}
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: (50.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${75+Number(this.props.titleMarginRight) + (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('School')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 51 : this.top.school)+Number(this.props.titleMarginUp)}mm`,
                    right: `${84+Number(this.props.titleMarginRight) + (this.props.examination.paper_type === 14 ? 28 : 0)}mm`,
                }}>
                {(this.props.student.school.name || '').persian()}
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: (54.5+Number(this.props.titleMarginUp))+'mm',
                    right: `${75 +Number(this.props.titleMarginRight)+ (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                    color: '#00AEEF',
                    display: this.props.background ? undefined : 'none',
                }}>
                {window.gettext('Grade')}:
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: `${(this.props.examination.paper_type === 14 ? 55 : this.top.grade)+Number(this.props.titleMarginUp)}mm`,
                    right: `${81+Number(this.props.titleMarginRight) + (this.props.examination.paper_type === 14 ? 27 : 0)}mm`,
                }}>
                {(this.props.student.grade.title || '').persian()}
                {this.props.student.clazz && this.props.student.clazz.name
                    ? ' - ' + window.gettext('Class') + ' ' + this.props.student.clazz.name.persian()
                    : null
                }
            </div>
        </div>;
    }
}
